import React, { useEffect } from "react";
import "../assets/css/DonationSection.css";
import { useNavigate } from "react-router-dom";
import donationBg from "../assets/images/Donation-bg.png"; 

const DonationSection = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const section = document.querySelector(".donation-section");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("slide-up");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    if (section) observer.observe(section);

    return () => observer.disconnect();
  }, []);

  return (
    <section
      className="donation-section"
      style={{ backgroundImage: `url(${donationBg})` }}
    >
      <div className="donation-content">
        <h2>
          "Your Kindness In Action — Explore How Every Contribution Creates
          Change."
        </h2>
        <p>
          Every donation is more than just a contribution — it’s a step toward a
          better tomorrow. Our blogs share powerful stories of lives touched,
          challenges overcome, and hope restored. From rural communities to
          urban families, your support makes real change possible. Join us in
          exploring these journeys and see how your kindness creates lasting
          impact.
        </p>
        {/* <button onClick={() => navigate("/donation-blogs")}>
          Donation Blogs →
        </button> */}
      </div>
    </section>
  );
};

export default DonationSection;
